import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MasterService } from '../../../services/master.service';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';

@Component({
  selector: 'app-requests-procedures-detail',
  templateUrl: './requests-procedures-detail.component.html',
  styleUrls: ['./requests-procedures-detail.component.scss']
})
export class RequestsProceduresDetailComponent implements OnInit {
  @Input() data: string;
  item: object;
  previousValues: any;
  private notRegister: string = 'no registrado';

  Form: FormGroup;
  genders = [{ id: 'H', name: 'Hombre' }, { id: 'M', name: 'Mujer' }];
  maritalStatus = [{ id: 'C', name: 'Casado' }, { id: 'S', name: 'Soltero' }, { id: 'V', name: 'Viudo' }, { id: 'D', name: 'Divorciado' }];

  constructor(private activeModal: NgbActiveModal,
    private masterService: MasterService,
    private fb: FormBuilder) {
  }

  ngOnInit(): void {
    const build = this.data.replace(/'/g, `"`);
    this.item = JSON.parse(build);
    this.Form = this.fb.group({
      name: [this.item['Name']],
      secondName: [this.item['SecondName']],
      lastName: [this.item['LastName']],
      secondLastName: [this.item['SecondLastName']],
      gender: [this.showGender(this.item['Gender'])],
      civilStatus: [this.showMarital(this.item['CivilStatus'])],
      document: [(this.item['DocumentType'] ? this.item['DocumentType'] : '') + ' ' + this.item['Document']],
      phone: [this.item['Phone']],
      phone2: [this.item['Phone2']],
      phone3: [this.item['Phone3']],
      email: [this.item['Email']],
      email2: [this.item['Email2']],
      email3: [this.item['Email3']],
      department: [''],
      province: [''],
      district: [''],
      country: [''],
      address: [this.item['Address']],
      dateNac: [this.item['DateNac'] ? moment(this.item['DateNac']).format('DD/MM/YYYY') : this.notRegister],
    });
    this.getDepartments(this.item['Ubigeo'], this.item['Country'], false);
    this.getProvinces(this.item['Ubigeo'], false);
    this.getDistrict(this.item['Ubigeo'], false);
    this.item['Country'] && this.getCountry(this.item['Country'], false);

    this.previousValues = this.item['previous-values'];
    if (this.previousValues && this.previousValues.Gender != undefined) { this.previousValues.Gender = this.showGender(this.previousValues.Gender); }
    if (this.previousValues && this.previousValues.CivilStatus != undefined) { this.previousValues.CivilStatus = this.showMarital(this.previousValues.CivilStatus); }
    if (this.previousValues && this.previousValues.Country != undefined) { this.getCountry(this.previousValues.Country, true); }
    if (this.previousValues && this.previousValues.Country != undefined && this.previousValues.Ubigeo != undefined) { this.previousValues.Ubigeo != '' ? this.getDepartments(this.previousValues.Ubigeo, this.previousValues.Country, true) : this.previousValues.Department = ''; }
    if (this.previousValues && this.previousValues.Country != undefined && this.previousValues.Ubigeo != undefined) { this.previousValues.Ubigeo != '' ? this.getProvinces(this.previousValues.Ubigeo, true) : this.previousValues.Province = ''; }
    if (this.previousValues && this.previousValues.Country != undefined && this.previousValues.Ubigeo != undefined) { this.previousValues.Ubigeo != '' ? this.getDistrict(this.previousValues.Ubigeo, true) : this.previousValues.District = ''; }
    if (this.previousValues && this.previousValues.DateNac != undefined) { this.previousValues.DateNac = (this.previousValues.DateNac ? moment(this.previousValues.DateNac).format('DD/MM/YYYY') : this.notRegister) }
  }

  close(): void {
    this.activeModal.close();
  }

  getDepartments(ubigeo_, country, previous: boolean): void {
    if (!ubigeo_ && country) { return; }
    const ubigeo = String(ubigeo_)[0] + String(ubigeo_)[1] + '0000';
    const sub = this.masterService.getList(3, country).pipe(finalize(() => {
      sub.unsubscribe();
    })).subscribe((response: any) => {
      const name = response.filter((r) => r.id === Number(ubigeo))[0].name;
      if (!previous)
        this.Form.get('department').setValue(name);
      else
        this.previousValues.Department = name;
    });
  }

  getProvinces(ubigeo_, previous: boolean): void {
    if (!ubigeo_) { return; }
    const department = String(ubigeo_)[0] + String(ubigeo_)[1] + String(ubigeo_)[2] + String(ubigeo_)[3] + '00';
    const sub = this.masterService.getList(4, Number(department)).pipe(finalize(
      () => {
        sub.unsubscribe();
      })).subscribe((response: any) => {
        const name = response.filter((r) => r.id === Number(department))[0].name;
        if (!previous)
          this.Form.get('province').setValue(name);
        else
          this.previousValues.Province = name;

      });
  }

  getDistrict(ubigeo_, previous: boolean): void {
    if (!ubigeo_) { return; }
    const province = String(ubigeo_)[0] + String(ubigeo_)[1] + String(ubigeo_)[2] + String(ubigeo_)[3] + '00';
    const sub = this.masterService.getList(9, Number(province)).pipe(finalize(
      () => {
        sub.unsubscribe();
      })).subscribe((response: any) => {
        const name = response.filter((r) => r.id === Number(ubigeo_))[0].name;
        if (!previous)
          this.Form.get('district').setValue(name);
        else
          this.previousValues.District = name;
      });
  }

  getCountry(id, previous: boolean): void {
    if (!id || id == 0) { return; }
    const sub = this.masterService.getList(10, id).pipe(finalize(
      () => {
        sub.unsubscribe();
      })).subscribe((response: any) => {
        const name = response[0].name;
        if (!previous)
          this.Form.get('country').setValue(name.toUpperCase());
        else
          this.previousValues.Country = name;
      });
  }

  showGender(id: string): string {
    if (!id) { return this.notRegister; }
    return this.genders.filter((g) => g.id === id)[0].name;
  }

  showMarital(id: string): string {
    if (!id) { return 'no registrado'; }
    return this.maritalStatus.filter((m) => m.id === id)[0].name;
  }
}
